import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'lib-sidebar',
  template: `
    <nav class="sidebar-nav d-flex flex-column flex-grow-1">
      <ng-content></ng-content>
    </nav>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  @HostBinding('class') class = 'd-flex flex-column flex-grow-1';
}
